export default __webpack_public_path__ + "47f498162fc6db8c7a13f60a78960689.png";